import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import Header from "./Header";
import { Link } from "react-router-dom";
import "react-medium-image-zoom/dist/styles.css";
import Footer from "./Footer";
// import { useParams } from "react-router-dom";

function Products() {
  // let { size_id } = useParams();
  // let { series_id } = useParams();

  const server_url = localStorage.getItem("server_url");
  const [searchTerm, setSearchTerm] = useState("");
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  // const [series, setSeries] = useState([]);
  const [refreshBanner, setRefreshBanner] = useState(false);
  // const [selectedSeries, setSelectedSeries] = useState(null);

  // Fetch Banner Data
  const getProducts = useCallback(async () => {
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      const res = await axios.post(
        `${server_url}products.php`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (res.data.status === "1") {
        setData(res.data.result);
        setFilteredData(res.data.result);
      } else {
        setData([]);
        setFilteredData([]);
        // toast.warning(res.data.error);
      }
    } catch (e) {
      toast("Please Try After Some Time.");
    }
  }, [server_url]);

 
  useEffect(() => {
    getProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getProducts]);

  useEffect(() => {
    if (refreshBanner) {
      getProducts();
      setRefreshBanner(false);
    }
  }, [refreshBanner, getProducts]);

  useEffect(() => {
    if (searchTerm === "") {
      setFilteredData(data);
    } else {
      const filtered = data.filter((item) =>
        item.product_name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredData(filtered);
    }
  }, [searchTerm, data]);

  useEffect(() => {
    let filtered = data;
    // if (selectedSeries !== null) {
    //   filtered = filtered.filter(
    //     (product) => product.series_id === selectedSeries
    //   );
    // }
    if (searchTerm) {
      filtered = filtered.filter((product) =>
        product.product_name.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    setFilteredData(filtered);
  }, [ searchTerm, data]);
  // selectedSeries,
  return (
    <>
      <div
        className="page-content header-clear-small"
        style={{ padding: "0px 10px" }}
      >
        <Header />
        <div className="search-page">
          <div
            className="header fixed left-0 w-full bg-white z-50"
            style={{ top: "68px", height: "auto", padding: "5px" }}
          >
            <div
              className="search-box search-header bg-theme card-style me-3 ms-3"
              style={{ margin: "0px 0px 0px 0px" }}
            >
              <i className="fa fa-search"></i>
              <input
                type="text"
                className="border-0"
                placeholder="What are you looking for?"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <Link
                className="clear-search mt-0"
                onClick={() => setSearchTerm("")}
              >
                <i className="fa fa-times color-red-dark"></i>
              </Link>
            </div>
          </div>
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
        <div className="page-content">
          <div className="row mb-0" style={{ padding: "0px 10px" }}>
            {filteredData.map((product, index) => (
              <Link
                to={{
                  pathname: "/Product_Detail/" + product.product_id,
                  state: { stateParam: true },
                }}
                key={index}
                className="col-6 pe-0"
                style={{ padding: "0px", marginTop: "15px" }}
              >
                <div
                  className="card card-style"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                  }}
                >
                  <img
                    src={product.product_image}
                    style={{
                      height: "180px",
                      objectFit: "cover",
                      cursor: "pointer",
                    }}
                    className="img-fluid"
                    alt={product.product_name}
                    // onClick={() => setSelectedImage(product.product_image)}
                  />
                  <div
                    className="content pb-0"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      margin: "0px 5px 5px 5px",
                    }}
                  >
                    {product.Product_discount_per && (
                      <div className="card-top m-2">
                        <span className="bg-blue-dark font-11 px-2 py-1 font-700 rounded-xs shadow-xxl">
                          {product.Product_discount_per} OFF
                        </span>
                      </div>
                    )}
                    <div className="p-2">
                      <h4
                        className="mb-0"
                        style={{ lineHeight: "15px", fontSize: "15px" }}
                      >
                        {product.product_name}
                      </h4>
                      <p
                        className="font-14 opacity-50"
                        style={{ lineHeight: "20px", paddingTop: "10px" }}
                      >
                        Size: {product.size_name}
                        <br />
                        Series: {product.product_design_name}
                      </p>
                    </div>
                    
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
      <Footer />

    </>
  );
}

export default Products;
